import {Space} from "antd";
import {ServiceOrderListEmptyState} from "./empty-state";
import {ServiceOrderListView} from "./list";
import {useGetStoreServicesOrdersContext} from "../../../../../service-feature/useCases/get-orders/context";
import {GetStoreServiceOrderProvider} from "../../../../../service-feature/useCases/get-order/context";

export function ServiceOrderList() {
  const {isLoading, isPreviousData, orders} = useGetStoreServicesOrdersContext();
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      {isPreviousData && <p>Loading next page… (previous data shown)</p>}
      {isLoading && <p>Loading orders...</p>}
      {!isLoading && orders.length > 0 ? (
        // <GetStoreServiceOrderProvider>
        <ServiceOrderListView />
      ) : (
        // </GetStoreServiceOrderProvider>
        <ServiceOrderListEmptyState />
      )}
    </Space>
  );
}
